import { useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminPayouts() {
    const [items, setItems] = useState([]);
    const [tab, setTab] = useState("pending");

    const load = () => api.get(`/admin/payouts?status=${tab}`).then((r) => setItems(r.data || []));
    useEffect(load, [tab]);

    const pay = async (id) => {
        const notes = prompt("Notes (optional)") || "";
        await api.post(`/admin/payouts/${id}/pay`, { notes });
        toast.success("Marked as paid");
        load();
    };
    const reject = async (id) => {
        const notes = prompt("Reason for rejection") || "";
        await api.post(`/admin/payouts/${id}/reject`, { notes });
        toast.success("Rejected & points refunded");
        load();
    };

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-7xl mx-auto px-6 py-12">
                <p className="eyebrow mb-2">ADMIN · PAYOUTS</p>
                <h1 className="h2 mb-8">Cashout queue</h1>
                <div className="flex gap-2 mb-6">
                    {["pending", "paid", "rejected"].map((f) => (
                        <button key={f} onClick={() => setTab(f)} className={`btn ${tab === f ? "btn-ink" : "btn-outline"} text-sm py-2 px-3`} data-testid={`tab-${f}`}>
                            {f.toUpperCase()}
                        </button>
                    ))}
                </div>
                <div className="card-base overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-cream">
                            <tr>
                                <th className="text-left p-3 text-xs uppercase">User</th>
                                <th className="text-left p-3 text-xs uppercase">Amount</th>
                                <th className="text-left p-3 text-xs uppercase">Method</th>
                                <th className="text-left p-3 text-xs uppercase">Details</th>
                                <th className="text-left p-3 text-xs uppercase">Requested</th>
                                <th className="text-left p-3 text-xs uppercase">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.length === 0 && <tr><td colSpan={6} className="text-center p-8 text-ink-600">No payouts.</td></tr>}
                            {items.map((p) => (
                                <tr key={p.id} className="border-t border-ink-200" data-testid={`payout-row-${p.id}`}>
                                    <td className="p-3">
                                        <div className="font-semibold">{p.user_name}</div>
                                        <div className="text-xs text-ink-600">{p.user_email}</div>
                                    </td>
                                    <td className="p-3 font-mono">${p.usd.toFixed(2)} ({p.points} pts)</td>
                                    <td className="p-3">{p.method}</td>
                                    <td className="p-3 text-xs text-ink-600">{p.details?.email || JSON.stringify(p.details)}</td>
                                    <td className="p-3 text-xs">{new Date(p.created_at).toLocaleString()}</td>
                                    <td className="p-3">
                                        {p.status === "pending" ? (
                                            <div className="flex gap-2">
                                                <button onClick={() => pay(p.id)} className="btn btn-ink text-xs py-1 px-2" data-testid={`pay-${p.id}`}>Mark paid</button>
                                                <button onClick={() => reject(p.id)} className="btn btn-outline text-xs py-1 px-2">Reject</button>
                                            </div>
                                        ) : (
                                            <span className="font-mono text-[10px]">{p.status.toUpperCase()}</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </main>
            <Footer />
        </div>
    );
}
